<template>
  <div>
    <iframe width="100%" height="1000px"
      src="https://lookerstudio.google.com/embed/reporting/fd8812b7-645b-4d32-9237-a803d14a06d6/page/C9mYF"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
